/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Info_TitleInputs */

const es_toast_info_title = /** @type {(inputs: Toast_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const en_toast_info_title = /** @type {(inputs: Toast_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information`)
};

/**
* | output |
* | --- |
* | "Information" |
*
* @param {Toast_Info_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_info_title = /** @type {((inputs?: Toast_Info_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Info_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_info_title(inputs)
	return en_toast_info_title(inputs)
});
export { toast_info_title as "toast.info_title" }